import { reactive, watch } from "vue";

/* LOAD CART FROM LOCAL STORAGE */
const savedCart = JSON.parse(localStorage.getItem("cart"));

export const cart = reactive({
  items: savedCart?.items || [],

  /* ADD ITEM TO CART */
  addItem(product, color, size) {
    if (!product || !color || !size) return;

    const existing = this.items.find(
      (i) => i.id === product.id && i.color === color && i.size === size
    );

    if (existing) {
      existing.qty += 1;
    } else {
      this.items.push({
        id: product.id,
        name: product.name,
        dressCode: product.dressCode,
        price: product.price,
        image: product.images?.[color]?.[0] || "",
        color,
        size,
        qty: 1,
      });
    }
  },

  /* INCREASE QUANTITY */
  increase(index) {
    if (this.items[index]) {
      this.items[index].qty += 1;
    }
  },

  /* DECREASE QUANTITY */
  decrease(index) {
    if (this.items[index] && this.items[index].qty > 1) {
      this.items[index].qty -= 1;
    }
  },

  /* REMOVE ITEM */
  removeItem(index) {
    this.items.splice(index, 1);
  },

  /* CLEAR CART (SAFE FOR REACTIVE) */
  clear() {
    this.items.length = 0;
  },

  /* TOTAL PRICE */
  totalAmount() {
    return this.items.reduce((sum, item) => sum + item.price * item.qty, 0);
  },
});

/* SAVE CART TO LOCAL STORAGE */
watch(
  () => cart.items,
  (items) => {
    localStorage.setItem("cart", JSON.stringify({ items }));
  },
  { deep: true }
);
